import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import FlowsIndex from './Index.vue';
import FlowEdit from './Edit.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_flows_index',
          component: FlowsIndex,
          meta: {
            featureFlag: FEATURE_FLAGS.ADVANCED_FLOWS,
            permissions: ['administrator'],
          },
        },
        {
          path: ':flowId/edit',
          name: 'settings_flows_edit',
          component: FlowEdit,
          meta: {
            featureFlag: FEATURE_FLAGS.ADVANCED_FLOWS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
